module.exports = __webpack_public_path__ + "static/media/invitatii-icon.98808bb5.svg";